import React, {useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {QueryUserArgs, UpdateUserInput, useGetUserQuery, User, useUpdateUserMutation} from '../../graphql';
import {UserEditContainer} from './container';
import {ErrorView} from '../GraphQL/ErrorView';
import {CombinedError} from "urql";

export const UserEditGraphQL = () => {
  const history = useHistory();
  const [errorState, setError] = useState<CombinedError | undefined>();
  const {id} = useParams<QueryUserArgs>();
  const [result, reexecuteQuery] = useGetUserQuery({variables: {id}, requestPolicy: 'network-only'});
  const {data, fetching, error} = result;
  const [updateUserResult, updateUserPromise] = useUpdateUserMutation();
  const updateUser = (values: UpdateUserInput) => {
    updateUserPromise({input: {...values, id}}).then((result) => {
      if (result.error) {
        console.dir(result.error);
        return setError(result.error);
      }
      history.push('/users');
    });
  }
  const userEditContainer = !data?.user ? <>User not found</> :
    <UserEditContainer
      user={data.user as User}
      updateUser={updateUser}
    />;

  return (
    <ErrorView fetching={fetching} errors={[error || errorState]}>
      {userEditContainer}
    </ErrorView>
  );
};
